/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'manager-dashboard',
    title: 'Manager Dashboard',
    type: 'basic',
    icon: 'mat_outline:dashboard',
    link: '/manager-dashboard',
  },
  {
    id: 'food-card',
    title: 'Food Card',
    subtitle: '멤버가 생성한 식단 카드',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'food-card.food-card-review',
        title: 'Food Card Review',
        type: 'basic',
        icon: 'mat_outline:business_center',
        link: '/food-card-review',
      },
      {
        id: 'food-card.food-card',
        title: 'Food Card',
        type: 'basic',
        icon: 'mat_outline:description',
        link: '/food-card',
      },
      {
        id: 'food-card.manager-complaint',
        title: 'Manager Complaint',
        type: 'basic',
        icon: 'mat_outline:report',
        link: '/manager-complaint',
      },
      {
        id: 'food-card.manager-assessment',
        title: 'Manager Assessment',
        type: 'basic',
        icon: 'mat_outline:star',
        link: '/manager-assessment',
      },
    ],
  },
  {
    id: 'food',
    title: 'Food',
    subtitle: 'Food 관련 도메인',
    type: 'group',
    icon: 'mat_outline:restaurant',
    children: [
      {
        id: 'food.food',
        title: 'Food',
        type: 'basic',
        icon: 'mat_outline:restaurant',
        link: '/food',
      },
      {
        id: 'food.food-brand',
        title: 'Food Brand',
        type: 'basic',
        icon: 'mat_outline:fastfood',
        link: '/food-brand',
      },
      {
        id: 'food.food-vendor',
        title: 'Food Vendor',
        type: 'basic',
        icon: 'mat_outline:store',
        link: '/food-vendor',
      },
      {
        id: 'food.food-serving-unit',
        title: 'Food Serving Unit',
        type: 'basic',
        icon: 'mat_outline:local_dining',
        link: '/food-serving-unit',
      },
      {
        id: 'food.food-category',
        title: 'Food Category',
        type: 'basic',
        icon: 'mat_outline:category',
        link: '/food-category',
      },
      {
        id: 'food.food-category-type',
        title: 'Food Category Type',
        type: 'basic',
        icon: 'mat_outline:label',
        link: '/food-category-type',
      },
      {
        id: 'food.food-card-failure-reason-type',
        title: 'Failure Reason Type',
        type: 'basic',
        icon: 'mat_outline:report',
        link: '/food-card-failure-reason-type',
      },
      {
        id: 'food.food-cooking-mode',
        title: 'Food Cooking Mode',
        type: 'basic',
        icon: 'heroicons_outline:adjustments-horizontal',
        link: '/food-cooking-mode',
      },
    ],
  },
  {
    id: 'supplement',
    title: 'Supplement',
    subtitle: 'Supplement 관련 도메인',
    type: 'group',
    icon: 'mat_outline:local_drink',
    children: [
      {
        id: 'supplement.supplement',
        title: 'Supplement',
        type: 'basic',
        icon: 'mat_outline:medication',
        link: '/supplement',
      },
      {
        id: 'supplement.supplement-brand',
        title: 'Supplement Brand',
        type: 'basic',
        icon: 'mat_outline:local_drink',
        link: '/supplement-brand',
      },
      {
        id: 'supplement.supplement-vendor',
        title: 'Supplement Vendor',
        type: 'basic',
        icon: 'mat_outline:store',
        link: '/supplement-vendor',
      },
      {
        id: 'supplement.supplement-serving-unit',
        title: 'Supplement Serving Unit',
        type: 'basic',
        icon: 'mat_outline:local_dining',
        link: '/supplement-serving-unit',
      },
      {
        id: 'supplement.supplement-category',
        title: 'Supplement Category',
        type: 'basic',
        icon: 'mat_outline:category',
        link: '/supplement-category',
      },
      {
        id: 'supplement.supplement-category-type',
        title: 'Supplement Category Type',
        type: 'basic',
        icon: 'mat_outline:label',
        link: '/supplement-category-type',
      },
    ],
  },
  {
    id: 'exercise',
    title: 'Exercise',
    subtitle: 'Exercise 관련 도메인',
    type: 'group',
    icon: 'mat_outline:fitness_center',
    children: [
      {
        id: 'exercise.exercise',
        title: 'Exercise',
        type: 'basic',
        icon: 'mat_outline:fitness_center',
        link: '/exercise',
      },
      {
        id: 'exercise.exercise-body-part',
        title: 'Exercise Body Part',
        type: 'basic',
        icon: 'mat_outline:settings_accessibility',
        link: '/exercise-body-part',
      },
      {
        id: 'exercise.exercise-equipment',
        title: 'Exercise Equipment',
        type: 'basic',
        icon: 'mat_outline:hardware',
        link: '/exercise-equipment',
      },
      {
        id: 'exercise.exercise-machine',
        title: 'Exercise Machine',
        type: 'basic',
        icon: 'mat_outline:sports',
        link: '/exercise-machine',
      },
      {
        id: 'exercise.exercise-target',
        title: 'Exercise Target',
        type: 'basic',
        icon: 'mat_outline:flag',
        link: '/exercise-target',
      },
      {
        id: 'exercise.exercise-category',
        title: 'Exercise Category',
        type: 'basic',
        icon: 'mat_outline:category',
        link: '/exercise-category',
      },
    ],
  },
  {
    id: 'expert',
    title: 'Expert',
    subtitle: 'Expert 관련 도메인',
    type: 'group',
    icon: 'mat_outline:person',
    children: [
      {
        id: 'expert.expert-workspace',
        title: 'Expert Workspace',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/expert-workspace',
      },
      {
        id: 'expert.expert-office',
        title: 'Expert Office',
        type: 'basic',
        icon: 'mat_outline:store',
        link: '/expert-office',
      },
      {
        id: 'expert.expert-partner',
        title: 'Expert Partner',
        type: 'basic',
        icon: 'mat_outline:people',
        link: '/expert-partner',
      },
      {
        id: 'expert.expert-workspace-subscription-cancellation-reason',
        title: 'Expert Subscription Cancellation Reason',
        type: 'basic',
        icon: 'mat_outline:cancel',
        link: '/expert-workspace-subscription-cancellation-reason',
      },
    ],
  },
  {
    id: 'user',
    title: 'User',
    subtitle: 'User 관련 도메인',
    type: 'group',
    icon: 'heroicons_outline:user-group',
    children: [
      {
        id: 'user.manager',
        title: 'Manager',
        type: 'basic',
        icon: 'mat_outline:manage_accounts',
        link: '/manager',
      },
      {
        id: 'user.member',
        title: 'Member',
        type: 'basic',
        icon: 'mat_outline:account_box',
        link: '/member',
      },
    ],
  },
  {
    id: 'coupon',
    title: 'Coupon',
    subtitle: 'Coupon 관련 도메인',
    type: 'group',
    icon: 'heroicons_outline:gift',
    children: [
      {
        id: 'coupon.subscription-coupon-profile',
        title: 'Subscription Coupon Profile',
        type: 'basic',
        icon: 'mat_outline:category',
        link: '/subscription-coupon-profile',
      },
      {
        id: 'coupon.subscription-coupon',
        title: 'Subscription Coupon',
        type: 'basic',
        icon: 'heroicons_outline:calendar',
        link: '/subscription-coupon',
      },
      {
        id: 'coupon.credit-point-coupon-profile',
        title: 'Credit Point Coupon Profile',
        type: 'basic',
        icon: 'mat_outline:assignment',
        link: '/credit-point-coupon-profile',
      },
      {
        id: 'coupon.credit-point-coupon',
        title: 'Credit Point Coupon',
        type: 'basic',
        icon: 'mat_outline:card_giftcard',
        link: '/credit-point-coupon',
      },
      {
        id: 'coupon.coupon-customer',
        title: 'Coupon Customer',
        type: 'basic',
        icon: 'heroicons_solid:building-office',
        link: '/coupon-customer',
      },
      {
        id: 'coupon.coupon-cancellation-reason',
        title: 'Coupon Cancellation Reason',
        type: 'basic',
        icon: 'mat_outline:cancel',
        link: '/coupon-cancellation-reason',
      },
    ],
  },
  {
    id: 'search',
    title: 'Search',
    subtitle: 'Search 관련 도메인',
    type: 'group',
    icon: 'mat_outline:search',
    children: [
      {
        id: 'search.user-dictionary-entry',
        title: 'User Dictionary Entry',
        type: 'basic',
        icon: 'mat_outline:menu_book',
        link: 'user-dictionary-entry',
      },
      {
        id: 'search.food-search-pinned-entry',
        title: 'Food Search Pinned Entry',
        type: 'basic',
        icon: 'mat_outline:restaurant',
        link: 'food-search-pinned-entry',
      },
      {
        id: 'search.exercise-search-pinned-entry',
        title: 'Exercise Search Pinned Entry',
        type: 'basic',
        icon: 'mat_outline:fitness_center',
        link: 'exercise-search-pinned-entry',
      },
    ],
  },
  {
    id: 'admin',
    title: 'Admin',
    subtitle: 'Admin 관련 도메인',
    type: 'group',
    icon: 'mat_outline:admin_panel_settings',
    children: [
      {
        id: 'admin.voice-of-customer',
        title: 'Voice of Customer',
        type: 'basic',
        icon: 'mat_outline:question_answer',
        link: 'voice-of-customer',
      },
      {
        id: 'admin.admin-control-panel',
        title: 'Admin Control Panel',
        type: 'basic',
        icon: 'mat_outline:admin_panel_settings',
        link: 'admin-control-panel',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 세팅',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: 'Settings',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];

export const seniorManagerNavigation: FuseNavigationItem[] = [
  {
    id: 'manager-dashboard',
    title: 'Manager Dashboard',
    type: 'basic',
    icon: 'mat_outline:dashboard',
    link: '/manager-dashboard',
  },
  {
    id: 'food-card',
    title: 'Food Card',
    subtitle: '멤버가 생성한 식단 카드',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'food-card.food-card-review',
        title: 'Food Card Review',
        type: 'basic',
        icon: 'mat_outline:business_center',
        link: '/food-card-review',
      },
      {
        id: 'food-card.manager-complaint',
        title: 'Manager Complaint',
        type: 'basic',
        icon: 'mat_outline:report',
        link: '/manager-complaint',
      },
      {
        id: 'food-card.manager-assessment',
        title: 'Manager Assessment',
        type: 'basic',
        icon: 'mat_outline:star',
        link: '/manager-assessment',
      },
    ],
  },
  {
    id: 'food',
    title: 'Food',
    subtitle: 'Food 관련 도메인',
    type: 'group',
    icon: 'mat_outline:restaurant',
    children: [
      {
        id: 'food.food',
        title: 'Food',
        type: 'basic',
        icon: 'mat_outline:restaurant',
        link: '/food',
      },
      {
        id: 'food.food-brand',
        title: 'Food Brand',
        type: 'basic',
        icon: 'mat_outline:fastfood',
        link: '/food-brand',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 세팅',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: 'Settings',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];

export const juniorManagerNavigation: FuseNavigationItem[] = [
  {
    id: 'manager-dashboard',
    title: 'Manager Dashboard',
    type: 'basic',
    icon: 'mat_outline:dashboard',
    link: '/manager-dashboard',
  },
  {
    id: 'food-card',
    title: 'Food Card',
    subtitle: '멤버가 생성한 식단 카드',
    type: 'group',
    icon: 'mat_outline:description',
    children: [
      {
        id: 'food-card.food-card-review',
        title: 'Food Card Review',
        type: 'basic',
        icon: 'mat_outline:business_center',
        link: '/food-card-review',
      },
      {
        id: 'food-card.manager-complaint',
        title: 'Manager Complaint',
        type: 'basic',
        icon: 'mat_outline:report',
        link: '/manager-complaint',
      },
      {
        id: 'food-card.manager-assessment',
        title: 'Manager Assessment',
        type: 'basic',
        icon: 'mat_outline:star',
        link: '/manager-assessment',
      },
    ],
  },
  {
    id: 'food',
    title: 'Food',
    subtitle: 'Food 관련 도메인',
    type: 'group',
    icon: 'mat_outline:restaurant',
    children: [
      {
        id: 'food.food',
        title: 'Food',
        type: 'basic',
        icon: 'mat_outline:restaurant',
        link: '/food',
      },
      {
        id: 'food.food-brand',
        title: 'Food Brand',
        type: 'basic',
        icon: 'mat_outline:fastfood',
        link: '/food-brand',
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    subtitle: '계정 관련 세팅',
    type: 'group',
    icon: 'mat_outline:settings',
    children: [
      {
        id: 'settings.settings',
        title: 'Settings',
        type: 'basic',
        icon: 'mat_outline:settings',
        link: '/settings',
      },
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'food',
    title: 'Food',
    type: 'basic',
    icon: 'mat_outline:restaurant',
    link: '/food',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'food',
    title: 'Food',
    type: 'basic',
    icon: 'mat_outline:restaurant',
    link: '/food',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'food',
    title: 'Food',
    type: 'basic',
    icon: 'mat_outline:restaurant',
    link: '/food',
  },
];
